// app/src/utils/constants/toastConfig.tsx
import { ToastOptions } from "react-toastify";

const toastConfig: ToastOptions = {
    position: "top-center",
    autoClose: 3500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

export default toastConfig;
